"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _hooks = require("../../utils/hooks");

var _GlobalNav = _interopRequireDefault(require("./GlobalNav.style"));

var _MegaMenu = _interopRequireDefault(require("./MenuVariants/MegaMenu"));

var _PrimaryMenu = _interopRequireDefault(require("./MenuVariants/PrimaryMenu"));

var _AccountNav = require("../AccountNav/AccountNav");

var GlobalNav = function GlobalNav(_ref) {
  var account = _ref.account,
      actions = _ref.actions,
      secondaryActions = _ref.secondaryActions,
      homeLink = _ref.homeLink,
      primaryLinks = _ref.primaryLinks,
      secondaryLinks = _ref.secondaryLinks,
      secondaryNavCtas = _ref.secondaryNavCtas,
      primaryActive = _ref.primaryActive,
      secondaryActive = _ref.secondaryActive,
      sliderFooterPrimaryNav = _ref.sliderFooterPrimaryNav,
      sliderFooterSecondaryNav = _ref.sliderFooterSecondaryNav,
      variation = _ref.variation,
      utilityNavLinks = _ref.utilityNavLinks,
      rest = _objectWithoutProperties(_ref, ["account", "actions", "secondaryActions", "homeLink", "primaryLinks", "secondaryLinks", "secondaryNavCtas", "primaryActive", "secondaryActive", "sliderFooterPrimaryNav", "sliderFooterSecondaryNav", "variation", "utilityNavLinks"]);

  var _ref2 = (0, _emotionTheming.useTheme)(),
      breakpoints = _ref2.breakpoints,
      globalNav = _ref2.globalNav;

  var windowWidth = (0, _hooks.useWindowWidth)(); // Breakpoint where the account options change to the menu icon

  var isLargeNav = windowWidth >= parseInt(breakpoints[globalNav.isLargeNavBreak], 10); // Breakpoint where the layout of the Slider's content change to accordions

  var isLargeSlider = windowWidth >= parseInt(breakpoints[globalNav.isLargeSliderBreak], 10);

  var megaMenuProps = _objectSpread({
    links: primaryLinks,
    homeLink: homeLink,
    actions: actions,
    secondaryActions: secondaryActions,
    sliderFooterPrimaryNav: sliderFooterPrimaryNav,
    sliderFooterSecondaryNav: sliderFooterSecondaryNav,
    account: account,
    isLargeNav: isLargeNav,
    isLargeSlider: isLargeSlider
  }, rest);

  var primaryMenuProps = _objectSpread({
    account: account,
    secondaryActions: secondaryActions,
    primaryLinks: primaryLinks,
    secondaryLinks: secondaryLinks,
    secondaryNavCtas: secondaryNavCtas,
    homeLink: homeLink,
    primaryActive: primaryActive,
    secondaryActive: secondaryActive,
    isLargeNav: isLargeNav,
    isLargeSlider: isLargeSlider,
    utilityNavLinks: utilityNavLinks
  }, rest);

  return /*#__PURE__*/_react.default.createElement(_GlobalNav.default, Object.assign({
    variation: variation
  }, rest), variation === 'mega' && /*#__PURE__*/_react.default.createElement(_MegaMenu.default, megaMenuProps), variation === 'primary' && /*#__PURE__*/_react.default.createElement(_PrimaryMenu.default, primaryMenuProps));
};

GlobalNav.propTypes = {
  account: _propTypes.default.shape(_AccountNav.accountPropTypes),
  actions: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  })),
  secondaryActions: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string,
    startIcon: _propTypes.default.string
  })),
  homeLink: _propTypes.default.string,
  primaryLinks: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string,
    description: _propTypes.default.string,
    navItems: _propTypes.default.arrayOf(_propTypes.default.shape({
      label: _propTypes.default.string,
      url: _propTypes.default.string
    }))
  })),
  secondaryNavCtas: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  })),
  secondaryLinks: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  })),
  primaryActive: _propTypes.default.string,
  secondaryActive: _propTypes.default.string,
  sliderFooterPrimaryNav: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  })),
  sliderFooterSecondaryNav: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  })),
  utilityNavLinks: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  })),
  variation: _propTypes.default.oneOf(['mega', 'primary'])
};
GlobalNav.defaultProps = {
  account: null,
  actions: [],
  secondaryActions: [],
  homeLink: '/',
  primaryLinks: [],
  secondaryLinks: [],
  secondaryNavCtas: [],
  primaryActive: '',
  secondaryActive: '',
  sliderFooterPrimaryNav: [],
  sliderFooterSecondaryNav: [],
  variation: 'mega',
  utilityNavLinks: []
};
var _default = GlobalNav;
exports.default = _default;